import Events from '@/scripts/lib/Events';
import { isLocalStorageEnabled } from '@/scripts/utils/base';

/** @template T */
export default class SimpleStorage {
   /** @type {Events<'change'>} */
   events = new Events();

   /** @type {T} */
   _value = null;

   _lsEnabled = isLocalStorageEnabled();

   _disabled = false;

   /**
    * @param {string} key 
    * @param {{ defaultValue: T }} param1 
    */
   constructor(key, { defaultValue = null } = {}) {
      this._defaultValue = defaultValue;
      this._key = key;

      this._init();
   }

   _init() {
      this._fetch();
   }

   get value() {
      return this._value;
   }

   set value(value) {
      this._setValue(value);
   }

   _setValue(value) {
      if (value === this._value || !this._lsEnabled) return false;
      this._value = value;
      this._save();

      this.events.emit('change', value);
      return true;
   }

   _fetch() {
      if (!this._lsEnabled || !(this._key in localStorage)) {
         this._value = this._defaultValue;
         return;
      }

      const value = localStorage[this._key];

      try {
         this._value = JSON.parse(value);
      } catch (e) {
         console.warn(`Couldn't parse localStorage["${this._key}"]:`, value);
         this._value = this._defaultValue;
      }

   }

   _save() {
      localStorage[this._key] = JSON.stringify(this._value);
   }

   get disabled() {
      return this._disabled;
   }

   set disabled(value) {
      if (this._disabled === value) return;
      this._disabled = value;
      this.events.emit('disable', value);
   }
}